<template>
  <a-layout-sider :width="'auto'">
    <transition-group name="air__menuFlyout__animation" :duration="1">
      <template v-for="(item, index) in renderedFlyoutItems" :key="index">
        <div
          :style="{
            left: `${item.itemDimensions.left + item.itemDimensions.width - 10}px`,
            top: `${item.itemDimensions.top}px`,
          }"
          :class="{
            [$style.air__menuFlyout]: true,
            [$style.air__menuFlyoutLeft]: settings.menuLayoutType === 'left',
            [$style.air__menuFlyout__black]: settings.flyoutMenuColor === 'dark',
            [$style.air__menuFlyout__white]: settings.flyoutMenuColor === 'white',
            [$style.air__menuFlyout__gray]: settings.flyoutMenuColor === 'gray',
          }"
        >
          <ul
            :class="$style.air__menuLeft__list"
            @mouseenter="handleFlyoutContainerOver(item.key)"
            @mouseleave="handleFlyoutOut(item.key)"
          >
            <template v-for="(menuItem, menuItemIndex) in item.items" :key="menuItemIndex">
              <item :item="menuItem" :styles="$style" :active-item="activeItem" />
            </template>
          </ul>
        </div>
      </template>
    </transition-group>
    <div
      :class="{
        [$style.air__menuLeft]: true,
        [$style.air__menuLeft__mobileToggled]: settings.isMobileMenuOpen,
        [$style.air__menuLeft__toggled]: settings.isMenuCollapsed,
        [$style.air__menuLeft__unfixed]: settings.isMenuUnfixed,
        [$style.air__menuLeft__shadow]: settings.isMenuShadow,
        [$style.air__menuLeft__flyout]: settings.flyoutMenuType === 'flyout',
        [$style.air__menuLeft__compact]: settings.flyoutMenuType === 'compact',
        [$style.air__menuLeft__blue]: settings.menuColor === 'blue',
        [$style.air__menuLeft__white]: settings.menuColor === 'white',
        [$style.air__menuLeft__gray]: settings.menuColor === 'gray',
        [$style.air__menuFlyout__black]:
          settings.flyoutMenuColor === 'dark' && settings.flyoutMenuType !== 'default',
        [$style.air__menuFlyout__white]:
          settings.flyoutMenuColor === 'white' && settings.flyoutMenuType !== 'default',
        [$style.air__menuFlyout__gray]:
          settings.flyoutMenuColor === 'gray' && settings.flyoutMenuType !== 'default',
      }"
    >
      <div :class="$style.air__menuLeft__outer">
        <a
          href="javascript: void(0);"
          :class="$style.air__menuLeft__mobileToggleButton"
          @click="toggleMobileMenu"
        >
          <span />
        </a>
        <a
          href="javascript: void(0);"
          :class="$style.air__menuLeft__toggleButton"
          @click="toggleMenu"
        >
          <span />
          <span />
        </a>
        <div :class="$style.air__menuLeft__logo">
          <div :class="$style.air__menuLeft__logo__letter">
            <svg id="Componente_11_1" data-name="Componente 11 – 1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="77" height="93" viewBox="0 0 77 93">
              <defs>
                <linearGradient id="linear-gradient" x1="1.176" y1="0.725" x2="0.5" y2="1" gradientUnits="objectBoundingBox">
                  <stop offset="0" stop-color="#1db9ec"/>
                  <stop offset="0.167" stop-color="#1db9ec"/>
                  <stop offset="0.523" stop-color="#1db9ec"/>
                  <stop offset="0.682" stop-color="#96c431"/>
                  <stop offset="1" stop-color="#8ebb2a"/>
                  <stop offset="1" stop-color="#93c12c"/>
                </linearGradient>
                <linearGradient id="linear-gradient-2" x1="1.226" y1="0.205" x2="0.641" y2="1" gradientUnits="objectBoundingBox">
                  <stop offset="0" stop-color="#1a4370"/>
                  <stop offset="0.003" stop-color="#1a4370"/>
                  <stop offset="0.207" stop-color="#1a4370"/>
                  <stop offset="0.589" stop-color="#1db9ec"/>
                  <stop offset="0.772" stop-color="#1db9ec"/>
                  <stop offset="1" stop-color="#1db9ec"/>
                </linearGradient>
              </defs>
              <circle id="Elipse_148" data-name="Elipse 148" cx="25.5" cy="25.5" r="25.5" transform="translate(0 42)" fill="url(#linear-gradient)"/>
              <circle id="Elipse_149" data-name="Elipse 149" cx="25.5" cy="25.5" r="25.5" transform="translate(26)" fill="url(#linear-gradient-2)"/>
              <g id="Grupo_5709" data-name="Grupo 5709" transform="translate(-89 -128)">
                <rect id="Rectángulo_2297" data-name="Rectángulo 2297" width="15" height="59" transform="translate(105 145)" fill="#fff"/>
                <rect id="Rectángulo_2299" data-name="Rectángulo 2299" width="15" height="59" transform="translate(140 145)" fill="#fff"/>
                <rect id="Rectángulo_2298" data-name="Rectángulo 2298" width="22" height="12" transform="translate(119 170)" fill="#fff"/>
              </g>
            </svg>
          </div>
          <div :class="$style.air__menuLeft__logo__name">
            Carta Porte
          </div>
          <div :class="$style.air__menuLeft__logo__descr">
            Holcim México
          </div>
        </div>
        <perfect-scrollbar>
          <div :class="$style.air__menuLeft__container">
            <ul :class="$style.air__menuLeft__list">
              <template v-for="(item, index) in menuData">
                <item
                  v-if="!item.children && !item.category"
                  :key="index"
                  :item="item"
                  :styles="$style"
                  :active-item="activeItem"
                />
                <sub-menu
                  v-if="item.children"
                  :key="index"
                  :item="item"
                  :styles="$style"
                  :active-item="activeItem"
                  :active-submenu="activeSubmenu"
                  :handle-submenu-click="handleSubmenuClick"
                  :handle-flyout-over="handleFlyoutOver"
                  :handle-flyout-out="handleFlyoutOut"
                />
                <category v-if="item.category" :key="index" :item="item" :styles="$style" />
              </template>
            </ul>
          </div>
        </perfect-scrollbar>
      </div>
    </div>
    <a
      href="javascript: void(0);"
      :class="$style.air__menuLeft__backdrop"
      @click="toggleMobileMenu"
    />
  </a-layout-sider>
</template>

<script>
import { ref, onMounted, computed, watch } from 'vue'
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import _ from 'lodash'
import { getMenuData } from '@/services/menu'
import SubMenu from './partials/submenu'
import Item from './partials/item'
import Category from './partials/category'

function decodeJwtPayload(token) {
  try {
    const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')
    const json = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join(''),
    )
    return JSON.parse(json)
  } catch {
    return null
  }
}

function getRoleFromStorages() {
  const directKeys = ['token', 'xToken', 'x-token', 'auth.token', 'jwt', 'access_token']
  for (const k of directKeys) {
    const raw = localStorage.getItem(k) || sessionStorage.getItem(k)
    if (typeof raw === 'string') {
      const payload = decodeJwtPayload(raw)
      if (payload?.role) return payload.role
    }
  }
  const objKeys = ['auth', 'user', 'session']
  for (const k of objKeys) {
    try {
      const obj =
        JSON.parse(localStorage.getItem(k) || 'null') ||
        JSON.parse(sessionStorage.getItem(k) || 'null') ||
        null
      const token = obj?.token
      if (typeof token === 'string') {
        const payload = decodeJwtPayload(token)
        if (payload?.role) return payload.role
      }
    } catch (_) {}
  }
  return null
}

function filterMenuByRole(items, role) {
  if (!role) return items
  return items.reduce((acc, item) => {
    if (item?.roles && !item.roles.includes(role)) {
      return acc
    }
    const copy = { ...item }
    if (Array.isArray(item.children)) {
      copy.children = filterMenuByRole(item.children, role)
    }
    acc.push(copy)
    return acc
  }, [])
}

export default {
  name: 'MenuLeft',
  components: { SubMenu, Item, Category },
  setup() {
    const store = useStore()
    const route = useRoute()
    const activeSubmenu = ref('')
    const activeItem = ref('')
    const renderedFlyoutItems = ref({})
    const flyoutTimers = ref({})
    const settings = computed(() => store.getters.settings)
    const pathname = computed(() => route.path)
    const flyoutActive = computed(() => {
      return (
        (settings.value.flyoutMenuType === 'flyout' ||
          settings.value.flyoutMenuType === 'compact' ||
          settings.value.isMenuCollapsed) &&
        !settings.value.isMobileView
      )
    })

    const currentRole = computed(() => {
      const u = store.getters?.['user/user'] || store.state?.user?.user || store.state?.user?.data
      return u?.role || getRoleFromStorages() || null
    })

    const menuData = computed(() => {
      const raw = getMenuData
      return filterMenuByRole(raw, currentRole.value)
    })

    const toggleMobileMenu = () => {
      const setting = 'isMobileMenuOpen'
      const value = !settings.value[setting]
      store.commit('CHANGE_SETTING', { setting, value })
    }

    const toggleMenu = () => {
      const setting = 'isMenuCollapsed'
      const value = !settings.value[setting]
      store.commit('CHANGE_SETTING', { setting, value })
    }

    const toggleSettings = () => {
      const setting = 'isSidebarOpen'
      const value = !settings.value[setting]
      store.commit('CHANGE_SETTING', { setting, value })
    }

    const handleSubmenuClick = key => {
      const currentKey = activeSubmenu.value
      if (flyoutActive.value) {
        return
      }
      activeSubmenu.value = currentKey === key ? '' : key
    }

    const setActiveItems = () => {
      const flattenItems = (items, key) =>
        items.reduce((flattenedItems, item) => {
          flattenedItems.push(item)
          if (Array.isArray(item[key])) {
            return flattenedItems.concat(flattenItems(item[key], key))
          }
          return flattenedItems
        }, [])
      const selectedItem =
        _.find(flattenItems(menuData.value, 'children'), ['url', pathname.value]) || {}
      const selectedSubmenu = menuData.value.reduce((key, parent) => {
        if (Array.isArray(parent.children)) {
          parent.children.map(child => {
            if (child.key === selectedItem.key) {
              key = parent
            }
            return ''
          })
        }
        return key
      })

      activeItem.value = selectedItem.key
      activeSubmenu.value = selectedSubmenu.key
    }

    const handleFlyoutOver = (event, key, items) => {
      if (flyoutActive.value) {
        clearInterval(flyoutTimers.value[key])
        const item = event.currentTarget
        const itemDimensions = item.getBoundingClientRect()
        renderedFlyoutItems.value = {
          ...renderedFlyoutItems.value,
          [key]: {
            key,
            itemDimensions,
            items,
          },
        }
      }
    }

    const handleFlyoutOut = key => {
      if (flyoutActive.value) {
        flyoutTimers.value[key] = setTimeout(() => {
          const updatedFlyoutItems = Object.assign({}, renderedFlyoutItems.value)
          delete updatedFlyoutItems[key]
          renderedFlyoutItems.value = {
            ...updatedFlyoutItems,
          }
        }, 100)
      }
    }

    const handleFlyoutContainerOver = key => {
      clearInterval(flyoutTimers.value[key])
    }

    onMounted(setActiveItems)
    watch(pathname, () => setActiveItems())

    return {
      menuData,
      activeSubmenu,
      activeItem,
      renderedFlyoutItems,
      flyoutTimers,
      settings,
      flyoutActive,
      toggleMobileMenu,
      toggleMenu,
      toggleSettings,
      handleSubmenuClick,
      handleFlyoutOver,
      handleFlyoutOut,
      handleFlyoutContainerOver,
    }
  },
}
</script>

<style lang="scss" module>
@import './style.module.scss';
</style>
